import KoioteAutomaticValueLabel from "./KoioteAutomaticValueLabel.vue";
import KoioteAutomaticValueLabelProperties from "./KoioteAutomaticValueLabelProperties.vue";
import KoioteAutomaticValueLabelWriteProperty from "./default.json";

export default {
  install(Vue) {
    Vue.component(KoioteAutomaticValueLabel.name, KoioteAutomaticValueLabel);
    Vue.component(KoioteAutomaticValueLabelProperties.name, KoioteAutomaticValueLabelProperties);
    Vue.prototype.$KoioteAutomaticValueLabelProperties = KoioteAutomaticValueLabelWriteProperty;
  },
};
